import { render, staticRenderFns } from "./DlgCampaignDelete.vue?vue&type=template&id=71cf2867&scoped=true&"
import script from "./DlgCampaignDelete.vue?vue&type=script&lang=js&"
export * from "./DlgCampaignDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71cf2867",
  null
  
)

export default component.exports